:host {
    display: inline-flex;
    vertical-align: middle;

    * {
        box-sizing: border-box;
    }
}

.badge {
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: var(--color-main);
    color: white;
    font-size: 11px;
    font-weight: 500;
    line-height: 16px;
    margin: 0;
    padding: 0;
}


.badge.label {
    min-width: 16px;
    height: 16px;
    padding: 4px;
    border-radius: 8px;
    // font-family: 'Lato-Bold';
}

.badge.dot {
    width: 6px;
    height: 6px;
    padding: 0;
    border-radius: 3px;
}